export class QuizSession {
  constructor(storage, uuidGenerator) {
    try {
      this.storage = storage;
      this.uuidGenerator = uuidGenerator;

      this.setFields();
      this.saveSessionIdInStorage();
    } catch (error) {
      throw error;
    }
  }

  setFields() {
    const sessionIdStorage = this.storage.get("session_id");
    if (sessionIdStorage) {
      this.sessionId = sessionIdStorage;
    } else {
      this.sessionId = this.generateId();
      if (typeof localStorage !== "undefined") {
        localStorage.removeItem("sendedNumberOfAnswer");
      }
    }
  }

  resetSessionId() {
    this.sessionId = this.generateId();
    this.saveSessionIdInStorage();
  }

  generateId() {
    return this.uuidGenerator();
  }

  saveSessionIdInStorage() {
    const sessionId = this.getId();
    if (this.storage) {
      this.storage.set("session_id", sessionId);
    }
  }

  getId() {
    return this.sessionId;
  }
}
